module.exports = __webpack_public_path__ + "img/xlh2.cd120da4.jpg";